import React from 'react';
import { FormControl, FormControlLabel, Radio, RadioGroup } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { SurveyComponent } from '../../../../models/SurveyTemplates';
import { Namespace } from '../../../../locales/translations';

interface MultipleChoiceFieldProps {
    field: SurveyComponent;
    value?: string;
    onChange?: (value: string) => void;
    disabled?: boolean;
}

const MultipleChoiceField: React.FC<MultipleChoiceFieldProps> = ({
    field,
    value = '',
    onChange,
    disabled = false
}) => {
    const { t } = useTranslation([Namespace.SURVEY_BUILDER]);

    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        onChange?.(event.target.value);
    };

    if (!field.options || field.options.length === 0) {
        return (
            <FormControl component="fieldset" fullWidth disabled={disabled}>
                <RadioGroup>
                    <FormControlLabel 
                        value="placeholder" 
                        control={<Radio />} 
                        label={t('field_messages.multiple_choice.add_options')}
                        disabled
                    />
                </RadioGroup>
            </FormControl>
        );
    }

    return (
        <FormControl component="fieldset" fullWidth disabled={disabled}>
            <RadioGroup
                value={value}
                onChange={handleChange}
            >
                {field.options.map((option) => (
                    <FormControlLabel
                        key={option.id}
                        value={option.value}
                        control={<Radio />}
                        label={option.label}
                    />
                ))}
            </RadioGroup>
        </FormControl>
    );
};

export default MultipleChoiceField;
